import {normalizeBlockTableForRender, normalizeBlockTableForUpdate} from "./block-table";
import {normalizeImportedTable} from "./imported-table";

export const tableNormalization = {
  normalizeBlockTableForRender,
  normalizeBlockTableForUpdate,
  normalizeImportedTable,
};